import { http } from "@/http";
import { Study } from "@/psychlab/types";

export const getStudy = async(id:string):Promise<Study> => {
	const { data } = await http.get(`studies/${id}`);
	return data;
};